export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8867.b6fe3b2f.jpg";